// extracted by mini-css-extract-plugin
export var captions = "full-bleed-module--captions--a33df";
export var content = "full-bleed-module--content--0b64f";
export var fb_wrap = "full-bleed-module--fb_wrap--50ea8";
export var fhjourn = "full-bleed-module--fhjourn--2ce42";
export var first = "full-bleed-module--first--3cb4b";
export var over_cont = "full-bleed-module--over_cont--81edd";
export var overlay = "full-bleed-module--overlay--5a54d";
export var video = "full-bleed-module--video--d4144";